'use es6';

export const RESTORE_MISSING_CUSTOM_WIDGET_NAME = 'RESTORE_MISSING_CUSTOM_WIDGET_NAME';
export const RESTORE_MISSING_GLOBAL_GROUP_PATH = 'RESTORE_MISSING_GLOBAL_GROUP_PATH';
export const RESTORE_MISSING_GLOBAL_WIDGET_NAME = 'RESTORE_MISSING_GLOBAL_WIDGET_NAME';
export const LOCAL_COPY_OF_GLOBAL_GROUP_MISING_ID = 'LOCAL_COPY_OF_GLOBAL_GROUP_MISING_ID';